module.exports = __webpack_public_path__ + "static/media/card.1914f8e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card.svg
// module id = 1250
// module chunks = 0